import { maxKeywordCount, maxKeywordLength } from '../../constants/maximums';
import { parseKeywordString } from '../../utils';

export const getCustomValidator = () => (value) => {
  const parsedKeywords = parseKeywordString(value);

  if (!parsedKeywords[0]) {
    // We can't use `parsedKeywords.length === 0` because when `value` is just whitespace, `parsedKeywords` will be an
    // array with an empty string as its only member.
    return ['TYPED_KEYWORDS_REQUIRED'];
  }

  const tooLongKeywords = parsedKeywords.filter(word => word.length > maxKeywordLength);

  if (tooLongKeywords.length > 0) {
    return [{
      key: 'KEYWORDS_TOO_LONG',
      data: {
        count: tooLongKeywords.length,
        max: maxKeywordLength,
        unit: tooLongKeywords.length === 1 ? 'keyword' : 'keywords',
        verb: tooLongKeywords.length === 1 ? 'exceeds' : 'exceed',
      },
    }];
  }

  if (parsedKeywords.length > maxKeywordCount) {
    return [{
      key: 'KEYWORDS_TOO_MANY',
      data: {
        count: parsedKeywords.length,
        max: maxKeywordCount,
      },
    }];
  }

  return [];
};
